import { FlexColumn, FlexRow, StyledButton } from '@gorila-shared-ui/components';
import { LabelMedium } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { EnhancedLabeledSelect } from '../ui/EnhancedLabeledSelect';
import { useGptAttendEvent } from './hooks/useGptAttendEvent';

export function GptAttendEventForm() {
  const { theme, css, classes } = useStyles();
  const { eventId, reasonOptions, onReasonChange, form, onSave, loading, formIsValid, closeAttend } =
    useGptAttendEvent();

  if (!eventId) return null;

  return (
    <FloatingCardContent
      flexible
      gap={theme.sizing.scale600}
    >
      <FlexColumn
        classNames={css({
          overflow: 'auto',
          height: '100%',
        })}
      >
        <LabelMedium className={classes.dataHeaderClass}>Atender evento</LabelMedium>
        <EnhancedLabeledSelect
          label="Motivo:"
          options={reasonOptions}
          value={form.code ? [{ id: form.code }] : undefined}
          onChange={onReasonChange}
          placeholder="Selecciona un motivo..."
          required
        />
      </FlexColumn>
      <FlexRow classNames={`${css({ alignItems: 'center', justifyContent: 'flex-end' })}`}>
        <FlexRow gap={theme.sizing.scale300}>
          <StyledButton
            kind="tertiary"
            onClick={closeAttend}
          >
            Cancelar
          </StyledButton>
          <StyledButton
            onClick={onSave}
            isLoading={loading}
            disabled={!formIsValid}
          >
            Atender
          </StyledButton>
        </FlexRow>
      </FlexRow>
    </FloatingCardContent>
  );
}
